import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { InternationalIcon } from '@arcade/web/icons/react'
import { spacing, Stack } from '@cash-design-system/react'
import { FormBlockerElementGiftCardElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { replaceWithCDNImageUrl } from '@cash-web/shared-util-url'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Note = styled.div`
  color: ${props => props.theme.colors.label};
  text-align: center;
`

const Card = styled.div<{ url?: string }>`
  background-image: url(${props => props.url});

  /* We expect the images to be the same dimensions as the card, but if they are not then we want to cover the background with the image. */
  background-size: cover;
  background-position: center;
  width: 21rem;
  height: 13.25rem;
  position: relative;
  border-radius: 1.2rem;
  box-shadow: ${props => props.theme.dropShadows.tile};
`

const Amount = styled.span`
  color: ${props => props.theme.colors.giftCardText};
  position: absolute;
  right: 1.25rem;
  top: 1rem;
  font-size: 1.5rem; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */
  font-weight: ${props => props.theme.weights.medium}; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */
`

const Caption = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${props => props.theme.typography.helpText};
  gap: ${spacing.xs};
`

export const GiftCardElement = (props: FormBlockerElementGiftCardElement) => {
  const { darkMode } = useTheme()

  const url = replaceWithCDNImageUrl({ url: darkMode ? props.card?.dark_url : props.card?.light_url })

  return (
    <Container>
      <Stack space={spacing.m}>
        {props.note && <Note>{props.note}</Note>}
        <Card url={url} role="img" aria-label={props.accessibility_label}>
          {props.amount_text && <Amount>{props.amount_text}</Amount>}
        </Card>
        {props.caption_text && (
          <Caption>
            <InternationalIcon size={24} />
            {props.caption_text}
          </Caption>
        )}
      </Stack>
    </Container>
  )
}
